<template>
    <div class="box job-campaign">
        <div class="notification">
            <strong>
                {{ customizationText('proposal_accepted_header', 'Everything is good to go!') }}
            </strong>

            <br />

            <span v-if="outstandingJobs.length">
                You can deliver your content below.
            </span>
            <span v-else>
                It looks like you are all caught up!
            </span>
        </div>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../../mixins/CampaignCustomizeMixin';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'JobStatus',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignCustomizeMixin
        ],

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true
            },

            /**
             * The outstanding jobs
             */
            outstandingJobs: {
                type:     Array,
                required: true
            }
        }
    }
</script>

